import { TicketCommentContent } from "@jugl-web/rest-api/tickets/models/common-types";

export const getTicketCommentText = (content: TicketCommentContent): string =>
  content.changes?.content ?? content.text;
